<template>
	<div>

		<template v-if="chance_info && curfield_power.chance_id != 3">
			<div class="gl_tit">
				关联商机
			</div>
			<div class="gl_list" >
				<div class="shangji">  
					<div class="sj_name" >
						{{chance_info.name || ''}}
					</div>
					<div class="sj_qyname" v-if="chance_info.customer">
						<div class="txt FlexRow">
							<img :src="urlhead + '/renz1.png'">
							{{chance_info.customer.name1 || ''}}
						</div>
					</div>
					<div class="sj_state ">
						<div class="state state1 " v-if="chance_info.state == 1">
							已签约
						</div>
						<div class="state state2 " v-else>
							未签约
						</div>
						<div class="state state3" v-if="chance_info.status">
							{{chance_info.status.name || ''}}
						</div>
					</div>
					<div class="sj_bottom">
						<div class="sj_text" v-if="chance_info.member">
							负责人：{{chance_info.member.name || ''}}
						</div>
						<div class="sj_btmfont">
							<div class="fonts FlexRow">
								商机预算：
								<span v-if="chance_info.amount">
									￥{{chance_info.amount || 0}}
								</span>
							</div>
							<div class="fonts FlexRow">
								预计签约时间：{{chance_info.signing_time || ''}}
							</div>
						</div>
						<div class="sj_btmfont">
							<div class="fonts FlexRow">
								创建时间：{{chance_info.create_time || ''}}
							</div>
							<div class="fonts FlexRow">
								最后跟进时间：{{chance_info.follow_time || ''}}
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--  -->
		</template>
		
		<template v-if="project_info && curfield_power.project_id != 3">
			<div class="gl_tit">
				关联项目
			</div>
			<div class="gl_list" >
				<div class="shangji">
					<div class="sj_name">
						{{project_info.name || ''}}
					</div>
					<div class="sj_qyname" v-if="project_info.customer">
						<div class="txt FlexRow">
							<img :src="urlhead + '/renz1.png'">
							{{project_info.customer.name1 || ''}}
						</div>
					</div>
					<div class="sj_state ">
						<div class="state state3" v-if="project_info.status == 1">
							进展中
						</div>
						<div class="state state1" v-else-if="project_info.status == 2">
							已完成
						</div>
						<div class="state state2" v-else>
							维护中
						</div>
						<div class="state state3" v-if="project_info.type_info">
							{{project_info.type_info.name || ''}}
						</div>
						<div class="state state3" v-if="project_info.stage">
							{{project_info.stage.name || ''}}
						</div>
					</div>
					<div class="sj_bottom">
						<div class="sj_text" v-if="project_info.member">
							负责人：{{project_info.member.name || ''}}
						</div>
						<div class="sj_btmfont">
							<div class="fonts FlexRow">
								开始时间：
								<span >
									{{project_info.start_time || ''}}
								</span>
							</div>
							<div class="fonts FlexRow">
								结束时间：
								<span >
									{{project_info.end_time || ''}}
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--  -->
		</template>
		
		<template v-if="contract_info && curfield_power.contract_id != 3">
			<div class="gl_tit">
				关联合同
			</div>
			<div class="gl_list" >
				<div class="shangji">
					<div class="bianhao">
						合同编号：{{contract_info.ht_code || ''}}
					</div>
					<div class="sj_name">
						{{contract_info.name || ''}} 
					</div>
					<div class="sj_qyname" v-if="contract_info.customer">
						<div class="txt FlexRow">
							<img :src="urlhead + '/renz1.png'">
							{{contract_info.customer.name1 || ''}}
						</div>
					</div>
					<div class="sj_bottom">
						<div class="sj_text" v-if="contract_info.member">
							负责人：{{contract_info.member.name || ''}}
						</div>
						<div class="sj_btmfont">
							<div class="fonts FlexRow" v-if="contract_info.signing_time">
								签约日期：
								<span >
									{{contract_info.signing_time || ''}}
								</span>
							</div>
							<div class="fonts FlexRow" v-if="contract_info.amount">
								合同总金额：
								<span >
									￥{{contract_info.amount || 0}}
								</span>
							</div>
						</div>
					</div>
					
				</div>
			</div>
		</template>
		
	</div>
</template>
<script>
	import {
		fn_retjson,
		retJSONArr,
		formatCurrency,
	} from "network/defaults";
	import {
		Chance_details,
		get_contract_details1,
		xmde_details,
	} from 'network/hk_operset'
	import {
		retfieldPower,
	} from 'network/kh_public'
	export default {
		name: "followuplink",
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			correlation:{
				type: Object | String,
				default: ()=>{
					return {}
				},
			},
		},
		data() {
			return {
				curfield_power: '',
				curkey: 'customer_follow_record',
				urlhead: 'https://scrm.51kuaiding.com/scrm/hktxcx/customer',
				chance_info: '',
				project_info: '',
				contract_info: '',
			}
		},
		created() {
			this.curfield_power = retfieldPower(this.curkey)
		},
		watch: {
			show() {
				if(this.show) {
					this.Refresh()
				}
			},
		},
		methods: {
			Refresh(){
				console.log(this.correlation,'this.correlation')
				if(!this.correlation)return;
				let obj = this.correlation
				if(obj.chance_id) {  // 关联商机
					this.fn_Chancedetails(obj.chance_id)
				}
				if(obj.project_id)  {  // 关联项目
					this.fn_projectDelait(obj.project_id)
				}
				if(obj.contract_id)  {  // 关联合同
					this.fn_contractDelait(obj.contract_id)
				}
			},
			// 商机详情
			fn_Chancedetails(id) {
				Chance_details(id).then(res => {
					if(res.code == 10000) {
						let obj = res.result
						let c_info = retJSONArr(obj.business_info)  || []
						let index = c_info.findIndex(v => v.field_sign == '商机预算')
						if (index != -1) {
							obj.amount = formatCurrency(c_info[index].content) || 0;
						}
						obj.signing_time = obj.signing_time ? obj.signing_time.slice(0,10) : '';
						obj.create_time = obj.create_time ? obj.create_time.slice(0,10) : '';
						obj.follow_time = obj.follow_time ? obj.follow_time.slice(0,10) : '';
						this.chance_info = obj
					}
				})
			},
			// 获取项目详情
			fn_projectDelait(id) {
				xmde_details(id).then(res => {
					if(res.code == 10000) {
						let obj = res.result
						obj.start_time = obj.start_time ? obj.start_time.slice(0,10) : '';
						obj.end_time = obj.end_time ? obj.end_time.slice(0,10) : '';
						this.project_info = obj
					}
				})
			},
			// 合同详情
			fn_contractDelait(id) {
				get_contract_details1(id).then(res => {
					if(res.code != 10000) return
					let obj = res.result
					let c_info = retJSONArr(obj.contract_info) || []
					let index = c_info.findIndex(v => v.field_sign == '合同总金额')
					if (index != -1) {
						obj.amount = formatCurrency(c_info[index].content) || 0;
					}
					obj.signing_time = obj.signing_time ? obj.signing_time.slice(0,10) : '';
					this.contract_info = obj	
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	
	.bianhao{
		font-size: 14px;
		color:#666;
		margin-bottom: 10px;
	}
	
	.gl_list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 40px;
	}

	.shangji::before {
		content: '';
		display: block;
		position: absolute;
		width: 294px;
		height: 7px;
		bottom: 0;
		left: 0;
		z-index: 3;
		background: rgba(42, 117, 234, 1);
	}

	.shangji::after {
		content: '';
		display: block;
		position: absolute;
		width: 100%;
		height: 7px;
		bottom: 0;
		left: 0;
		z-index: 2;
		background: rgba(212, 227, 252, 1);
	}

	.shangji {
		position: relative;
		width: 344px;
	
		border: 1px solid rgba(220, 223, 230, 1);
		border-bottom: none;
		padding: 25px;
		// margin: 0 20px 20px 0;

		.delebtn {
			position: absolute;
			right: 40px;
			cursor: pointer;
			top: 20px;

			i {
				color: #666;
				font-size: 15px;
			}
		}

		.sj_name {
			font-size: 16px;
			font-weight: 550;
			color: rgba(56, 56, 56, 1);
			margin-bottom: 10px;
		}

		.sj_qyname {
			margin-bottom: 10px;
			display: flex;
			align-items: center;

			.tit {
				font-size: 14px;
				color: rgba(56, 56, 56, 1);
				margin-right: 5px;
			}

			.txt {
				font-size: 12px;
				color: rgba(150, 150, 150, 1);

				img {
					width: 15px;
					height: 15px;
					display: block;
					margin-right: 6px;
				}
			}
		}

		.sj_state {
			margin-bottom: 10px;
			display: flex;
			align-items: center;

			.state {
				height: 20px;
				padding: 0 10px;
				border-radius: 3px;
				font-size: 12px;
				display:flex;
				align-items: center;
				justify-content: center;
				margin-right: 7px;
			}

			.state1 {
				color: rgba(82, 196, 26, 1);
				background: rgba(235, 255, 236, 1);
			}

			.state2 {
				color: rgba(255, 125, 0, 1);
				background: rgba(249, 237, 217, 1);
			}

			.state3 {
				color: rgba(43, 117, 235, 1);
				background: rgba(235, 241, 255, 1);
			}
		}

		.sj_bottom {
			border-top: 1px solid rgba(246, 246, 246, 1);
			padding-top: 10px;

			.sj_text {
				font-size: 13px;
				color: rgba(150, 150, 150, 1);
				margin-bottom: 8px;
			}

			.sj_btmfont {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 8px;

				.fonts {
					flex: 1;
					white-space: nowrap;
					justify-content: flex-start;
					font-size: 12px;
					color: rgba(150, 150, 150, 1);
				}
			}
		}
	}
	
	.gl_tit::before {
		content: '';
		display: block;
		width: 3px;
		height: 20px;
		background: rgba(43, 117, 235, 1);
		margin-right: 8px;
	}

	.gl_tit {
		display: flex;
		align-items: center;
		font-size: 16px;
		font-weight: 550;
		margin-bottom: 18px;
		color: rgba(56, 56, 56, 1);

		.gl_btn {
			width: 75px;
			height: 27px;
			border-radius: 3px;
			background: rgba(42, 117, 234, 1);
			font-size: 14px;
			cursor: pointer;
			color: #fff;
			margin-left: 10px;
			i {
				color: #fff;
				font-size: 14px;
			}
		}
	}
</style>
